
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SiteTransfer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteTransfer"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromSiteId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transferredBy"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"User"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"transferredAt"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":169}};
    doc.loc.source = {"body":"#import \"../users/UserFragment.graphql\"\n\nfragment SiteTransfer on SiteTransfer {\n    fromSiteId,\n    reason,\n    transferredBy {\n      ...User\n    }\n    transferredAt\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../users/UserFragment.graphql").definitions));


      module.exports = doc;
    
